import React from 'react';

export default function CollapsibleHeader({ topic, isExpanded, subtitle }) {
  return (
    <div className="collapsible-trigger" aria-expanded={isExpanded}>
      <div className="collapsible-trigger__body">
        <span className="collapsible-trigger__title">{topic}</span>
        {subtitle && <span className="collapsible-trigger__subtitle">{subtitle}</span>}
        <span className="collapsible-trigger__hint">
          {isExpanded ? 'แตะเพื่อย่อ' : 'แตะเพื่อดู'}
        </span>
      </div>
      <span className="collapsible-trigger__chevron" aria-hidden="true">
        {isExpanded ? '▲' : '▼'}
      </span>
    </div>
  );
}
